<div [formGroup]="parentForm()" class="flex flex-col gap-(--gap-loose)">
  <div class="flex flex-row gap-(--gap-loose) max-w-200 min-w-145">
    <ces-text-field
      [maxLength]="50"
      [minLength]="3"
      [required]="true"
      [unicityArray]="existingNames()"
      class="w-full"
      formControlName="name"
      id="name"
      [label]="'common.labels.name' | transloco"
      [placeholder]="'common.placeholders.measureName' | transloco"
      unicityKey="name" />
    <ces-text-field
      [maxLength]="50"
      class="w-full"
      formControlName="externalId"
      id="externalId"
      [label]="'entities.measure.fields.timeserie' | transloco" />
  </div>

  <div class="max-w-80">
    <ces-select-field
      [filter]="true"
      [required]="true"
      class="w-full"
      formControlName="measureTypeId"
      id="measureTypeId"
      [label]="'common.labels.type' | transloco"
      optionsStore="MeasureType" />
  </div>

  <div class="flex flex-row gap-(--gap-loose) max-w-200 min-w-145">
    <ces-select-field
      [filter]="false"
      [options]="FREQUENCY_OPTIONS"
      [required]="true"
      class="w-full"
      formControlName="frequency"
      id="frequency"
      [label]="'common.labels.samplingFrequency' | transloco" />

    <div class="max-w-80">
      <ces-hourpicker-field
        [required]="true"
        class="w-full"
        formControlName="hour"
        id="hour"
        [label]="'common.labels.startTime' | transloco" />
    </div>
  </div>

  @if (showDayOfWeek() || showMonth() || showDayOfMonth()) {
    <div class="flex flex-row gap-(--gap-loose) max-w-200 min-w-145 flex-wrap">
      @if (showDayOfWeek()) {
        <ces-select-field
          [filter]="false"
          [options]="DAY_OF_WEEK_OPTIONS"
          [required]="true"
          class="flex-1 min-w-50 max-w-80"
          formControlName="dayOfWeek"
          id="dayOfWeek"
          [label]="'entities.automaticMeasure.fields.dayOfWeek' | transloco" />
      }

      @if (showDayOfMonth()) {
        <ces-select-field
          [filter]="false"
          [options]="DAY_OF_MONTH_OPTIONS"
          [required]="true"
          class="flex-1 min-w-50 max-w-80"
          formControlName="dayOfMonth"
          id="dayOfMonth"
          [label]="'entities.automaticMeasure.fields.dayOfMonth' | transloco" />
      }

      @if (showMonth()) {
        <ces-select-field
          [filter]="false"
          [options]="MONTH_OPTIONS"
          [required]="true"
          class="flex-1 min-w-50 max-w-80"
          formControlName="month"
          id="month"
          [label]="'entities.automaticMeasure.fields.month' | transloco" />
      }
    </div>
  }

  <div class="max-w-80">
    <ces-select-field
      [filter]="true"
      [required]="true"
      class="w-full"
      formControlName="unitId"
      [label]="'common.labels.unit' | transloco"
      [options]="unitOptions()"
      optionLabel="label"
      optionValue="value"
      [placeholder]="'common.placeholders.selectUnit' | transloco" />
  </div>

  <div class="max-w-196">
    <ces-select-field
      [filter]="true"
      [multiSelect]="true"
      [optionsFilter]="{ property: 'assetId', value: assetId(), operator: 'equals' }"
      [storeLoadParams]="[assetId()]"
      [emptyFilterMessage]="'common.messages.noResults' | transloco"
      [emptyMessage]="'common.messages.noData' | transloco"
      formControlName="locationIds"
      [label]="'common.labels.locations' | transloco"
      optionsStore="Location"
      [placeholder]="'common.placeholders.selectLocations' | transloco"
      storeLoadMethod="getLocationsByAsset" />
  </div>

  <div class="flex items-center gap-(--space-2)">
    <p-toggleswitch id="overwrite" formControlName="overwrite" />
    <label for="overwrite">{{ 'entities.automaticMeasure.fields.overwrite' | transloco }}</label>
    <i
      class="pi pi-info-circle text-sm text-(color:--text-secondary) cursor-help"
      [pTooltip]="'entities.automaticMeasure.tooltips.overwrite' | transloco"
      tooltipPosition="top"></i>
  </div>

  <div class="max-w-196">
    <ces-text-field
      id="description"
      formControlName="description"
      class="w-full"
      type="textarea"
      [rows]="3"
      [label]="'common.labels.description' | transloco" />
  </div>
</div>
